export const CLEAR_SETTINGS = 'clear_settings'
export const ADD_SETTING = 'add_setting'
export const SETTING_ADDED = 'filters_setting_added'
export const REMOVE_LAST_SETTING = 'remove_last_setting'
export const UPDATE_LAST_SETTING = 'update_last_setting'
export const UPDATE_SETTINGS_IDS = 'update_settings_ids'
export const UPDATE_CURRENT_SETTING_ID = 'update_current_setting_id'
export const APPLY_ADJUST = 'apply_adjust'
export const SET_IMAGE_STATUS = 'set_image_status'
export const TOGGLE_SHOULD_CONFIRM_REVERT = 'toggle_should_confirm_revert'
